import { useNavigate, useSearchParams } from 'react-router-dom';
import { back_arrow_icon } from 'utils/images';
import useEvents from 'hooks/store/events/useEvents';

const DefaultComponent = ({ text }: { text: string }) => <p className="user_title">{text}</p>;

const BackComponent = ({ text, navigateTo, onBack }: { text: string; navigateTo: string; onBack?: () => void }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const tab = searchParams.get('tab');

  let nextText: string = text;
  window.location.href.includes('regionId');
  switch (true) {
    case tab === 'Regions':
      nextText = 'Regions List';
      break;
    case window.location.href.includes('regionId'):
      nextText = 'Regions List';
      break;
    default:
      break;
  }

  return (
    <p className="back_btn return_page">
      <span
        className="back_icon"
        onClick={() => {
          onBack?.();
          if (text === 'Matches List' || text === 'Group Details') {
            navigate(-1);
          } else if (text === 'Pairs') {
            navigate('/pairs');
          } else {
            navigate(navigateTo);
          }
        }}>
        <img src={back_arrow_icon} alt="back_arrow_icon" />
      </span>
      Back to <span className="back_text"> {nextText}</span>
    </p>
  );
};

// Event creation started from the Invite modal goes back to that modal instead of the Events List.
const AddEventsBackComponent = () => {
  const [searchParams] = useSearchParams();
  const { inviteToNewEvent, setState } = useEvents();
  if (!inviteToNewEvent || searchParams.get('inviteFrom') !== inviteToNewEvent.sourceEventId) {
    return <BackComponent text={'Events List'} navigateTo="/events" />;
  }
  const { guestLabel, sourceEventId } = inviteToNewEvent;
  return (
    <BackComponent
      // Plural, matching the invite modal title regardless of how many were selected.
      text={`Invite ${guestLabel}s to Event`}
      navigateTo={`/events-detail/${sourceEventId}`}
      onBack={() => setState({ inviteToNewEvent: { ...inviteToNewEvent, isReturning: true } })}
    />
  );
};

export const HeaderBackData = {
  '/prompts/:id': <BackComponent text="Prompts" navigateTo="/prompts" />,
  '/participants/admin-users': <DefaultComponent text={'Participants'} />,
  '/participants/mentors': <DefaultComponent text={'Participants'} />,
  '/participants/mentees': <DefaultComponent text={'Participants'} />,
  '/participants/admin-users/add-admin-user': (
    <BackComponent text="Admin User List" navigateTo="/participants/admin-users" />
  ),
  '/partners': <DefaultComponent text={'Partners & Regions'} />,
  '/partners/partner-detail': <BackComponent text="Partner List" navigateTo="/partners" />,
  '/partners/add-partner-user': <BackComponent text="Partner List" navigateTo="/partners" />,
  '/participants/mentors/add-mentor': <BackComponent text="Mentor List" navigateTo="/participants/mentors" />,
  '/participants/mentors/edit-mentor/:id': <BackComponent text="Mentor List" navigateTo="/participants/mentors" />,
  '/participants/mentors/mentor-details/:id': <BackComponent text="Mentor List" navigateTo="/participants/mentors" />,
  '/participants/group/mentors/mentor-details/:id': <BackComponent text="Group Details" navigateTo="/groups" />,
  '/participants/pair-details/mentors/mentor-details/:id': <BackComponent text="Pairs" navigateTo="/pairs" />,
  '/participants/mentees/edit-mentee/:id': <BackComponent text="Mentees List" navigateTo="/participants/mentees" />,
  '/participants/mentees/add-mentee': <BackComponent text={'Mentees List'} navigateTo="/participants/mentees" />,
  '/participants/mentees/mentee-details': <BackComponent text={'Mentees List'} navigateTo="/participants/mentees" />,
  '/participants/group/mentees/mentee-details': <BackComponent text={'Group Details'} navigateTo="/groups" />,
  '/participants/pair-details/mentees/mentee-details': <BackComponent text={'Pairs'} navigateTo="/pairs" />,
  '/prompts': <DefaultComponent text={'Prompts'} />,
  '/matching': <DefaultComponent text={'Matching'} />,
  '/matching/potential-matches': <DefaultComponent text={'Matching'} />,
  '/matching/matching-questions': <DefaultComponent text={'Matching'} />,
  '/matching/potential-match-details': <BackComponent text={'Matches List'} navigateTo="/matching/potential-matches" />,
  '/matching/selected-match-details': <BackComponent text={'Matches List'} navigateTo="/matching/potential-matches" />,
  '/matching/mentees/:menteeId/potential-matches': (
    <BackComponent text={'Matching'} navigateTo="/participants/mentees?tab=matching" />
  ),
  '/pairs': <DefaultComponent text={'Pairs'} />,
  '/pairs/pair-activity': <BackComponent text={'Pairs List'} navigateTo="/pairs" />,
  '/events': <DefaultComponent text={'Events'} />,
  '/add-events': <AddEventsBackComponent />,
  '/events-detail/:id': <BackComponent text={'Events'} navigateTo="/events" />,
  '/content': <DefaultComponent text={'Content'} />,
  '/content/create-content': <BackComponent text={'Content List'} navigateTo="/content" />,
  '/content/create-survey': <BackComponent text={'Content List'} navigateTo="/content" />,
  '/groups': <DefaultComponent text={'Groups'} />,
  '/add-groups': <BackComponent text={'Groups List'} navigateTo="/groups" />,
  '/groups-detail/:id': <BackComponent text={'Groups List'} navigateTo="/groups" />,
  '/messages/team-inbox': <DefaultComponent text={'Messages'} />,
  '/messages/team-inbox/:id': <DefaultComponent text={'Messages'} />,
  '/messages/team-inbox/:chatType/:chatId': <DefaultComponent text={'Messages'} />,
  '/messages/pair-chats': <DefaultComponent text={'Messages'} />,
  '/messages/pair-chats/:id': <DefaultComponent text={'Messages'} />,
  '/messages/pair-chats/:chatType/:chatId': <DefaultComponent text={'Messages'} />,
  '/reporting': <DefaultComponent text={'Progress on Goals'} />,
  '/focus-messages': <DefaultComponent text={'Flag Alert'} />,
  '/focus-messages/:id': <BackComponent text={'Flag Alert'} navigateTo="/focus-messages" />,
};
